var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokenHeartDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.32856L20.9445 8.71019L14.0556 12.0918L19.2222 17.1643M17.5 5.32856C14.401 1.78289 9.22261 0.687341 5.33979 3.93411C1.45695 7.18088 0.910297 12.6094 3.95951 16.4492C6.49473 19.642 14.1672 26.3755 16.6818 28.5549C16.963 28.7988 17.1037 28.9207 17.2679 28.9687C17.411 29.0104 17.5677 29.0104 17.711 28.9687C17.8751 28.9207 18.0156 28.7988 18.2971 28.5549C20.8117 26.3755 28.484 19.642 31.0193 16.4492C34.0685 12.6094 33.5885 7.14673 29.6389 3.93411C25.6894 0.721496 20.599 1.78289 17.5 5.32856Z",
    stroke: "black",
    strokeWidth: 3.904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenHeartDefault);
export default __webpack_public_path__ + "static/media/broken-heart-default.0b685d875e968927c0d51e667fc3814a.svg";
export { ForwardRef as ReactComponent };